<template>
  <div class="videomonitor-container">
    <div class="video-wrapper">
      <zj-camera-preview
        class="video-item"
        :cameraId="cameraId"
        :cameraName="cameraName"
        :autoplay="autoplay"
      />
    </div>
    <div class="video-title">
      {{cameraName}}
      <div class="video-item-spread" @click="handleSpread"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeViewComponentVideoMonitorControl",
  componentName: "HomeViewComponentVideoMonitorControl",
  props: {
    cameraId: String,
    cameraName: String,
    autoplay:{
      type:Boolean,
      default:false
    }
  },
  methods:{
    handleSpread(){
      this.$emit("spread",this.cameraId,this.cameraName);
    }
  }
};
</script>